import React, { useEffect } from "react";
import "../../signin/tutorSignin.css";
import {
  Col,
  Row,
  Typography,
  Form,
  Layout,
  Input,
  Button,
  Image,
} from "antd";
import { useNavigate, useLocation } from "react-router";
import { Post } from "../../../config/api/post";
import { ASSOCIATE_AUTH } from "../../../config/constants/api";
import { FiLock } from "react-icons/fi";
import swal from "sweetalert";
import { ImageUrl } from "../../../helpers/Functions";

function AssociateForgotPassword3() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (!state?.email || !state?.code) {
      navigate("/associate/forgot-password", { replace: true });
    }
  }, [state, navigate]);

  const onFinish = (values) => {
    setLoading(true);
    Post(ASSOCIATE_AUTH.resetPassword, {
      password: values.password,
      confirmPassword: values.confirmPassword,
      email: state.email,
      code: state.code,
    })
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          swal("Success", response?.data?.message, "success");
          navigate("/associate/signin", { replace: true });
        } else {
          swal(
            "Oops!",
            response?.data?.message || response?.response?.data?.message,
            "error"
          );
        }
      })
      .catch(() => {
        swal("Oops!", "Unable to reset password", "error");
        setLoading(false);
      });
  };

  return (
    <Layout className="AuthBackground tutorSigninLayout" style={{ minHeight: "100vh" }}>
      <Row className="tutorSigninRow" gutter={[0, 0]}>
        <Col xs={24} lg={12} className="tutorSigninFormCol">
          <div className="tutorSigninFormShell">
            <div className="tutorSigninFormCard">
              <Image
                src={ImageUrl("fav.png")}
                className="tutorSigninLogo"
                alt="WrightCo Academy"
                preview={false}
              />
              <Typography.Title level={2} className="fontFamily1 tutorSigninTitle">
                New password
              </Typography.Title>
              <Typography.Paragraph className="tutorSigninSubtitle">
                Set a new password for your associate account.
              </Typography.Paragraph>

              <Form layout="vertical" className="loginForm tutorSigninForm" onFinish={onFinish}>
                <Form.Item
                  label="Password*"
                  name="password"
                  rules={[{ required: true, message: "Password is required" }]}
                >
                  <Input.Password
                    size="large"
                    prefix={<FiLock />}
                    placeholder="Enter new password"
                    className="tutorSigninInput"
                  />
                </Form.Item>
                <Form.Item
                  label="Confirm Password*"
                  name="confirmPassword"
                  rules={[
                    { required: true, message: "Please confirm your password" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error("Passwords do not match"));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    size="large"
                    prefix={<FiLock />}
                    placeholder="Confirm new password"
                    className="tutorSigninInput"
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="loginButton tutorSigninSubmit"
                    block
                  >
                    {loading ? "Loading..." : "Update password"}
                  </Button>
                </Form.Item>
              </Form>

              <Typography.Text className="tutorSigninFooterText fontFamily1">
                <span
                  className="tutorSigninRegisterLink"
                  role="button"
                  tabIndex={0}
                  onClick={() => navigate("/associate/signin")}
                >
                  Back to associate login
                </span>
              </Typography.Text>
            </div>
          </div>
        </Col>
        <Col xs={0} lg={12} className="tutorSigninPromoCol">
          <div className="tutorSigninPromoBg" aria-hidden />
          <div className="tutorSigninPromoContent">
            <Typography.Title level={2} className="tutorSigninPromoTitle">
              Almost done
            </Typography.Title>
            <Typography.Paragraph className="tutorSigninPromoSubtitle">
              Choose a strong password to secure your associate account.
            </Typography.Paragraph>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}

export default AssociateForgotPassword3;
